// EmailReplyBox.jsx — zdieľaný „Odpovedať e-mailom" pre Reklamácie / Dopyty / Spis / Partneri / NEO …
// Odoslané cez /api/email/reply (SMTP) + kópia do vlákna. Podpis = prihlásený. Prílohy: foto + vygenerovaná KAMIR listina (8.A).
import React, { useState } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { normPhone } from '../utils/phone.js'
import DocumentCreator from './DocumentCreator.jsx'

const C = { line: 'rgba(0,0,0,.12)', t2: '#5F5E5A', t3: '#8a897f', brand: '#D85A30', link: '#185FA5', bg: '#f4f3ee', ok: '#0F6E56', okBg: '#e8f6f0', err: '#B42318', errBg: '#fdecea' }
const inp = { width: '100%', padding: '7px 9px', fontSize: 13, fontFamily: 'inherit', border: `1px solid ${C.line}`, borderRadius: 8, outline: 'none', boxSizing: 'border-box' }
const btn = (bg, color) => ({ padding: '6px 12px', borderRadius: 8, border: bg ? 'none' : `1px solid ${C.line}`, background: bg || '#fff', color: color || C.t2, cursor: 'pointer', fontFamily: 'inherit', fontSize: 13 })
const chip = { display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 8px', borderRadius: 6, background: '#fff', border: `1px solid ${C.line}`, fontSize: 11.5, color: C.t2 }

export default function EmailReplyBox({ target = {}, defaultTo = '', defaultSubject = '', defaultText = '', fotos = [], attach = [], onSent, label = 'Odpovedať e-mailom', smsPhone = '' }) {
  const [open, setOpen] = useState(false)
  const [sms, setSms] = useState(true)  // informatívna SMS zákazníkovi (ak je smsPhone) — dokumentový vzor (Mirko 22.7.)
  const [form, setForm] = useState({ to: '', cc: '', subject: '', text: '', atts: [] })
  const [docAtts, setDocAtts] = useState([])      // vygenerované listiny [{url, filename}]
  const [docModal, setDocModal] = useState(false)
  const [showCc, setShowCc] = useState(false)
  const [sig, setSig] = useState('')
  const [editSig, setEditSig] = useState(false)
  const [sending, setSending] = useState(false)
  const [msg, setMsg] = useState(null)            // { t, type:'err'|'ok'|'info' }
  const [sent, setSent] = useState(null)          // { to, atts } po úspešnom odoslaní

  const openBox = async () => {
    let s = sig
    if (!s) { try { const r = await fetchAuth('/api/email/my-signature'); const j = await r.json(); s = j.signature || ''; setSig(s) } catch (_) {} }
    setForm({ to: defaultTo || '', cc: '', subject: defaultSubject || '', text: (defaultText ? defaultText + '\n\n' : '') + s, atts: [] })
    setDocAtts([]); setShowCc(false); setMsg(null); setSent(null); setOpen(true)
  }
  const send = async () => {
    if (!form.to.trim()) { setMsg({ t: 'Zadaj príjemcu (e-mail) — bez neho sa odpoveď neodošle.', type: 'err' }); return }
    setSending(true); setMsg(null)
    try {
      const attachments = [...form.atts.map(p => ({ path: p })), ...docAtts.map(d => ({ path: d.url, filename: d.filename })), ...attach.map(a => ({ path: a.url || a.path, filename: a.filename }))]
      const body = { ...target, to: form.to, cc: form.cc || undefined, subject: form.subject, text: form.text, attachments }
      const r = await fetchAuth('/api/email/reply', { method: 'POST', body: JSON.stringify(body) })
      const j = await r.json(); if (!r.ok) throw new Error(j.error || 'Server odmietol odoslanie')
      // informatívna SMS zákazníkovi (dokumentový vzor, Mirko 22.7.) — naviazaná do vlákna
      if (smsPhone && sms) {
        try { await fetchAuth('/api/sms/send', { method: 'POST', body: JSON.stringify({ to: smsPhone, text: 'Dobry den, prave sme Vam odpovedali na Vas email. V pripade otazok volajte 0918 443 675. KAMIR', entity_type: target.dopyt_id ? 'dopyt' : (target.project_id ? 'project' : ''), entity_id: target.dopyt_id || target.project_id || '' }) }) } catch (_) {}
      }
      setSent({ to: form.to, atts: attachments.length }); setMsg(null); if (onSent) onSent()
    } catch (e) { setMsg({ t: 'Odpoveď sa NEodoslala: ' + e.message, type: 'err' }) } finally { setSending(false) }
  }
  const saveSig = async () => {
    try { const r = await fetchAuth('/api/email/my-signature', { method: 'PUT', body: JSON.stringify({ signature: sig }) }); if (!r.ok) throw new Error(); setEditSig(false); setMsg({ t: 'Podpis uložený — použije sa v ďalších odpovediach', type: 'ok' }) } catch (_) { setMsg({ t: 'Podpis sa neuložil', type: 'err' }) }
  }

  if (!open) return <button onClick={openBox} style={btn(null)}>{label}</button>

  // ── Po úspešnom odoslaní: výrazné zelené potvrdenie (Mirko musí VIDIEŤ že prešlo) ──
  if (sent) return (
    <div style={{ border: `1.5px solid ${C.ok}`, borderRadius: 10, padding: 14, background: C.okBg, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: C.ok }}>Odoslané na {sent.to}</div>
      <div style={{ fontSize: 12.5, color: C.t2 }}>Kópia uložená do vlákna{sent.atts ? ` · ${sent.atts} príloha/y` : ''}. Záznam „Odoslané…" nájdeš nižšie v spise.</div>
      <div style={{ display: 'flex', gap: 6, marginTop: 2 }}>
        <button onClick={() => { setSent(null); setOpen(false) }} style={btn(C.ok, '#fff')}>Hotovo</button>
        <button onClick={openBox} style={btn(null)}>Napísať ďalšiu</button>
      </div>
    </div>
  )

  return (
    <div style={{ border: `1px solid ${C.line}`, borderRadius: 10, padding: 12, background: C.bg, display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ fontSize: 11, color: C.t2, textTransform: 'uppercase', fontWeight: 600 }}>Odpovedať e-mailom — kópia sa uloží do vlákna</div>
      <div style={{ display: 'flex', gap: 6 }}>
        <input placeholder="komu (e-mail)" value={form.to} onChange={e => setForm(s => ({ ...s, to: e.target.value }))} style={{ ...inp, flex: 1 }} />
        {!showCc && <button onClick={() => setShowCc(true)} style={btn(null)} title="Pridať kópiu (CC)">+ Kópia</button>}
      </div>
      {showCc && <input placeholder="kópia — CC (e-mail, oddeľ čiarkou)" value={form.cc} onChange={e => setForm(s => ({ ...s, cc: e.target.value }))} style={inp} />}
      <input placeholder="predmet" value={form.subject} onChange={e => setForm(s => ({ ...s, subject: e.target.value }))} style={inp} />
      <textarea placeholder="text…" value={form.text} onChange={e => setForm(s => ({ ...s, text: e.target.value }))} rows={8} style={{ ...inp, resize: 'vertical' }} />
      {fotos.length > 0 && (
        <div style={{ fontSize: 11, color: C.t2 }}>Prílohy (foto):
          {fotos.map((p, i) => (
            <label key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginLeft: 8, cursor: 'pointer' }}>
              <input type="checkbox" checked={form.atts.includes(p)} onChange={e => setForm(s => ({ ...s, atts: e.target.checked ? [...s.atts, p] : s.atts.filter(x => x !== p) }))} />
              {String(p).split('/').pop()}
            </label>
          ))}
        </div>
      )}
      {attach.length > 0 && <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>{attach.map((a, i) => <span key={i} style={{ ...chip, color: C.ok }}>{a.filename}</span>)}</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <button onClick={() => setDocModal(true)} style={btn(null)}>Vytvoriť a priložiť listinu</button>
        {docAtts.map((d, i) => (
          <span key={i} style={chip}>{d.filename}<span onClick={() => setDocAtts(a => a.filter((_, j) => j !== i))} style={{ cursor: 'pointer', color: C.brand, fontWeight: 700 }} title="Odobrať prílohu">✕</span></span>
        ))}
      </div>
      <div style={{ fontSize: 11 }}>
        {!editSig ? <span onClick={() => setEditSig(true)} style={{ color: C.link, cursor: 'pointer' }}>Upraviť môj podpis</span>
          : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ color: C.t2 }}>Tvoj štandardný podpis (meno, funkcia, tel, e-mail + firemný blok):</div>
              <textarea value={sig} onChange={e => setSig(e.target.value)} rows={9} style={{ ...inp, resize: 'vertical' }} />
              <div style={{ display: 'flex', gap: 6 }}><button onClick={saveSig} style={btn(C.brand, '#fff')}>Uložiť podpis</button><button onClick={() => setEditSig(false)} style={btn(null)}>Zrušiť</button></div>
            </div>
          )}
      </div>
      {msg && (
        msg.type === 'err'
          ? <div style={{ fontSize: 13, fontWeight: 600, color: C.err, background: C.errBg, border: `1.5px solid ${C.err}`, borderRadius: 8, padding: '8px 10px' }}>{msg.t}</div>
          : <div style={{ fontSize: 12, color: msg.type === 'ok' ? C.ok : C.t2 }}>{msg.t}</div>
      )}
      {smsPhone && (
        <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, color: C.t2, padding: '2px 0' }}>
          <input type="checkbox" checked={sms} onChange={e => setSms(e.target.checked)} />
          <span>Poslať zákazníkovi aj SMS, že sme odpovedali ({normPhone(smsPhone)})</span>
        </label>
      )}
      <div style={{ display: 'flex', gap: 6 }}>
        <button onClick={send} disabled={sending} style={btn(C.brand, '#fff')}>{sending ? 'Odosielam…' : 'Odoslať'}</button>
        <button onClick={() => setOpen(false)} style={btn(null)}>Zrušiť</button>
      </div>
      {docModal && <DocumentCreator open onClose={() => setDocModal(false)} context={{ recipient: form.to, projectId: target.project_id || '' }}
        onGenerated={(r) => { if (r && r.url) { setDocAtts(a => [...a, { url: r.url, filename: r.filename || 'listina.pdf' }]); setMsg({ t: 'Listina priložená k odpovedi', type: 'ok' }) } setDocModal(false) }} />}
    </div>
  )
}
